module.exports = __webpack_public_path__ + "media/OnFocus_Media_reel.d8290db2.mp4";